// extracted by mini-css-extract-plugin
export default {"AlertTableFirstElement":"AlertsTableRow_AlertTableFirstElement__e8gkQ"};